// User Settings imports
const { UPDATE_FIELD } = require('client-v2/user-settings/containers/account-form/actions')
// Sibling imports
const SelfUserRecord = require('./record')

function userReducer(state = new SelfUserRecord(), { type, payload }) {
  switch (type) {
    case UPDATE_FIELD:
      switch (payload.name) {
        case 'username':
          return state.set('username', payload.value)
        case 'user_photo':
          return state.set('photo_url', payload.value)
        default:
          return state
      }
    default:
      return state
  }
}

module.exports = userReducer
